import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import qs from 'qs';
import { BrowserRouter, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import registerServiceWorker from './registerServiceWorker';
import { resize, verifySessionId, verifyUser } from './actions';
import * as endpoints from './helpers/endpoints';

import store from './store';
import App from './containers/app';

import './main.css';

window.addEventListener('resize', () => {
    store.dispatch(resize(window.outerWidth));
});
store.dispatch(resize(window.outerWidth));

//Split out the query param
const getUrlParameter = variable => {
    let query = window.location.search.substring(1);
    return qs.parse(query)[variable];
};

//Grabs session id from url param
if (getUrlParameter('session')) {
    store.dispatch(verifySessionId(getUrlParameter('session')));
} else if (process.env.NODE_ENV === 'development') {
    //For development
    if (sessionStorage.getItem('t')) {
        store.dispatch(
            verifyUser(sessionStorage.getItem('t'), sessionStorage.getItem('r'))
        );
    } else if (window.location.pathname !== '/login') {
        document.location = '/login';
    }
} else if (sessionStorage.getItem('r') && sessionStorage.getItem('t')) {
    store.dispatch(
        verifyUser(sessionStorage.getItem('t'), sessionStorage.getItem('r'))
    );
} else {
    //Redirect to adportal
    window.location.replace(endpoints.REDIRECT_AD_PORTAL);
}

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <Route component={App} />
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js